"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _intents = _interopRequireWildcard(require("@ux/intents"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _default = function () {
  const intents = new _intents.default();
  intents.create('@ux/tray-menu', {
    styleProperties: [_intents.enums.properties.BACKGROUND_COLOR, _intents.enums.properties.FONT_SIZE],
    interactions: [_intents.enums.interactions.CHOSEN],
    features: {
      // Menu button
      [_intents.enums.features.INDICATOR]: {
        styleProperties: [_intents.enums.properties.FONT_SIZE, _intents.enums.properties.FONT_WEIGHT, _intents.enums.properties.BORDER_RADIUS]
      }
    }
  });

  // Menu container default
  intents.uxTrayMenu.backgroundColor = 'transparent';
  intents.uxTrayMenu.fontSize = intents.ux.text.fontSize;

  // Menu contrainer open
  intents.uxTrayMenuChosen.backgroundColor = intents.ux.boxLowContrast.backgroundColor;

  // Menu button
  intents.uxTrayMenu.indicator.fontSize = intents.ux.textAction.fontSize;
  intents.uxTrayMenu.indicator.fontWeight = intents.ux.textAction.fontWeight;
  intents.uxTrayMenu.indicator.borderRadius = intents.ux.action.borderRadius;
  return intents;
}();
exports.default = _default;